/**
 * The top bar of the Breakdowns tab, pinned while the sheet scrolls: where this
 * breakdown's answers came from ("From Provider Connect · Jun 23, 2026"; the
 * handled-by chip beside it shows only to super admins and covering FTC), then
 * the outcome buttons, over a purple rule. Who the plan and the patient are sits
 * in the columns below (PlanSummary).
 */
import React from "react";

import { identityMismatchOf, sourceOf } from "./sheetModel";
import "./breakdownSheet.css";

export default function SheetHeader({ policy, breakdown, handledBy, actions }) {
  if (!policy) return null;
  const source = breakdown ? sourceOf(breakdown, policy) : "";
  const mismatch = identityMismatchOf(breakdown);
  return (
    <div className="bs-bar-wrap" data-testid="breakdown-sheet-header">
      <div className="bs-bar">
        <div className="bs-bar-src">
          {source ? <span>{source}</span> : null}
          {handledBy}
        </div>
        <div className="bs-bar-acts">{actions}</div>
      </div>
      <div className="bs-bar-rule" />
      {mismatch ? <div className="bs-identity" role="alert" data-testid="breakdown-identity-mismatch">{mismatch}</div> : null}
    </div>
  );
}
